///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { closeUserDialog, deleteUser } from '../../store/users-list.actions';
import { AbstractDialogComponent } from '../../../dialog-manager/abstract-dialog.component';
import { SuiUserDTO } from '../../../generated/shared-sui-types.model';
import { Actions, ofType } from '@ngrx/effects';

@Component({
    selector: 'winde-user-delete-dialog',
    templateUrl: './user-delete-dialog.component.html',
    standalone: false
})
export class UserDeleteDialogComponent extends AbstractDialogComponent {
    public user: SuiUserDTO = this.data.payload;

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly dialogRef: MatDialogRef<UserDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { payload: SuiUserDTO }
    ) {
        super();
        this.actions$.pipe(ofType(closeUserDialog)).subscribe(() => {
            this.dialogRef.close();
        });
    }

    confirmDelete(id: number): void {
        this.store.dispatch(deleteUser({ id, deletedUser: this.user }));
    }
}
